var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41325 8.52262L2.16325 14.7726C1.98713 14.9487 1.74826 15.0477 1.49918 15.0477C1.25011 15.0477 1.01124 14.9487 0.835122 14.7726C0.659002 14.5965 0.560059 14.3576 0.560059 14.1086C0.560059 13.8595 0.659002 13.6206 0.835122 13.4445L6.42184 7.85934L0.836685 2.27262C0.749479 2.18542 0.680303 2.08189 0.633108 1.96795C0.585912 1.85401 0.561621 1.73189 0.561621 1.60856C0.561621 1.48523 0.585912 1.36311 0.633108 1.24917C0.680303 1.13523 0.749479 1.0317 0.836685 0.944497C0.923891 0.857291 1.02742 0.788116 1.14136 0.74092C1.2553 0.693725 1.37742 0.669434 1.50075 0.669434C1.62408 0.669434 1.7462 0.693725 1.86014 0.74092C1.97408 0.788116 2.0776 0.857291 2.16481 0.944497L8.41481 7.1945C8.50211 7.2817 8.57133 7.38527 8.61852 7.49928C8.6657 7.61329 8.68991 7.7355 8.68977 7.85888C8.68962 7.98227 8.66512 8.10442 8.61767 8.21832C8.57022 8.33222 8.50075 8.43563 8.41325 8.52262Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.f95bffb1d910c0a63b5b50e5d1349d0f.svg";
export { ForwardRef as ReactComponent };